module.exports = __webpack_public_path__ + "img/cursor.826e503d.png";